import React, { forwardRef, useEffect } from "react";
import { config } from "../../../../config/domain";
import InputField from "../../../generic/inputField";
import TocDropdown from "../../../generic/tocDropdown";
import { IListObj } from "../../../types/genericTypes";

const reasons: Array<IListObj> = [
  {
    value: "",
    display: "Select Closure Reason"
  },
  {
    value: "Stopped dealing in Equities Commodity",
    display: "Stopped dealing in equities & commodity"
  },
  {
    value: "Dissatisfied with services",
    display: "Dissatisfied with services"
  },
  {
    value: "Transferred from city",
    display: "Transferred from city"
  },
  {
    value: "Others",
    display: "Others",
  },
];
export const DpTradingOptions = (props: any) => {
  return (
    <>
      <div className="custom--row tradingAccnt dpTradingAcctWrap">
        {/* space-mb-20  for reason other than others*/}
        {props.dpOptions &&
          props.dpOptions.length > 2 &&
          props.selectedAcc.toLowerCase().includes("demat") && (
            <>
              <div className="form-field custom-col noLeftPAdding">
                <div>
                  <label className="input-label">DP Details</label>
                  <TocDropdown
                    selectedValue={
                      props.dpOptions.length > 0
                        ? props.selectedDp
                        : "Select DP Details"
                    }
                    dropdownOptions={props.dpOptions}
                    onSelect={(val) => {
                      if (val) {
                        if (props.setErrors)
                          props.setErrors({ ...props.errors, selectedDp: "" });
                        props.setSelectedDp(val);
                      }
                    }}
                    disabled={props.disabled}
                    isSearchable={false}
                  />
                  {props.errors && props.errors.dp && (
                    <p className="help_text red">{props.errors.selectedDp}</p>
                  )}
                </div>
              </div>
            </>
          )}
        {props.dpOptions &&
          props.dpOptions.length === 2 &&
          props.selectedAcc.toLowerCase().includes("demat") && (
            <div className="form-field custom-col noLeftPAdding">
              <label className="input-label">DP Details</label>

              <InputField
                type="text"
                defaultValue={props.selectedDp}
                onChange={() => {}}
                onBlur={() => {}}
                placeholder=""
                disabled={true}
              />
            </div>
          )}
        {props.selectedAcc.toLowerCase() === "trading" && (
          <div className="form-field custom-col noLeftPAdding dpTradingAcctWrap-trade">
            <label className="input-label">Trading Account</label>

            <InputField
              type="text"
              defaultValue={props.accountCode}
              onChange={() => {}}
              onBlur={() => {}}
              placeholder=""
              disabled={true}
            />
          </div>
        )}

        <>
          <div className="form-field custom-col noLeftPAdding">
            <div>
              <label className="input-label">Closure Reason</label>
              <TocDropdown
                selectedValue={props.reason ? props.reason : reasons[0].value}
                dropdownOptions={reasons}
                onSelect={(val) => {
                  props.setReason(val);
                  props.setErrors({ ...props.errors, reason: "" });
                }}
                isSearchable={false}
                disabled={props.disabled || props.jointHolderErrorMsg}
              />
              {props.errors && props.errors.reason !== "" && (
                <p className="help_text red">{props.errors.reason}</p>
              )}
            </div>
          </div>
        </>

        {props.errorMsg !== "" && (
          <div className="custom-col-100 noLeftPAdding">
            <p className="help_text red">
              {props.errorMsg}
              {props.errorMsg ===
                "Please get your default demat account changed to another before closure" && (
                <a
                  href={
                    config.rootUrl + "clientarea?scroll=AdvisorDetailsSection"
                  }
                  className="link_to_rm fs-13"
                >
                  {" "}
                  Contact your RM
                </a>
              )}
            </p>
          </div>
        )}

        {/* {props.errors && props.errors.dp && (
          <div className="custom-col-100">
            <p className="error">{props.errors.dp}</p>
          </div>
        )} */}
      </div>
    </>
  );
};
